import { render, staticRenderFns } from "./GroupLayerSimplified.vue?vue&type=template&id=3dc5f430&scoped=true"
import script from "./GroupLayerSimplified.vue?vue&type=script&lang=ts"
export * from "./GroupLayerSimplified.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./GroupLayerSimplified.vue?vue&type=style&index=0&id=3dc5f430&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3dc5f430",
  null
  ,true
)

export default component.exports